'use client'

import React from 'react'
import { Box } from '@mantine/core'

import { ServiceItem } from '@/types/interfaces/service-item'
import { ServiceItemCardType } from '@/types/enums/ServiceItem'
import { PageLocation } from '@nile/mantine-theme/analytics'
import { useBreakpoint } from '@/hooks/useBreakpoints'

import { CardSlider } from '@/components/Refresh/CardSlider/CardSlider'
import { CardSliderCard } from '@/components/Refresh/CardSlider/CardSliderCard'
import ServiceItemCard from '@/components/ServiceItemCard'

import classes from './StoreSkuCarousel.module.css'

interface StoreSkuCarouselProps {
    services?: ServiceItem[]
    cardType: ServiceItemCardType
    showDescription?: boolean
    pageLocation?: PageLocation
    additionalInformation?: Record<string, any>
    gap?: number
}

export default function StoreSkuCarousel({
    services,
    cardType,
    showDescription,
    pageLocation,
    additionalInformation,
    gap = 18,
}: StoreSkuCarouselProps) {
    const { isSm } = useBreakpoint()

    if (!services || services.length === 0) {
        return null
    }

    return (
        <Box className={classes.skuCarouselWrap}>
            <Box className={classes.carouselContainer}>
                {services.length > 0 ? (
                    <CardSlider gap={24} startX={isSm ? 16 : 24} endGap={18} useTranslateForStartX initialPosition="end">
                        {services.map((service, index) => {
                            const uniqueKey = `${service.id}-${index}`
                            return (
                                <CardSliderCard key={uniqueKey}>
                                    <ServiceItemCard
                                        service={service}
                                        showDescription={showDescription}
                                        pageLocation={pageLocation || PageLocation.CATEGORY}
                                        additionalInformation={additionalInformation}
                                    />
                                </CardSliderCard>
                            )
                        })}
                    </CardSlider>
                ) : null}
            </Box>
        </Box>
    )
}
